<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div
    *ngIf="
      emergencyContactPhoneNumberAudits && emergencyContactPhoneNumberAudits.length > 0;
      else noAudits
    "
  >
    <sd-portal-audit-detail-list
      [audits]="emergencyContactPhoneNumberAudits"
      (nextPage)="onNextPage()"
    >
    </sd-portal-audit-detail-list>
  </div>

  <ng-template #noAudits> No Emergency Contact Phone Number audits </ng-template>
</ng-template>
